export const getLifecycle = () => {
	let isDuringBuild = false
	let hasWindow = false
	let inCI = false
	try {
		// biome-ignore lint/suspicious/noExplicitAny: Waku
		isDuringBuild = (globalThis as any).__WAKU_IS_BUILD__ === true
	} catch (_) {}

	try {
		hasWindow = typeof window !== 'undefined'
	} catch (_) {}

	try {
		/* CI detection is intentionally centralized here so callers don't need
		 * to reach into process.env directly. */
		const env: Record<string, string | undefined> | undefined =
			typeof process !== 'undefined'
				? (process.env as Record<string, string | undefined>)
				: undefined

		inCI =
			!hasWindow &&
			!!env &&
			(env.CI === 'true' ||
				env.CI === '1' ||
				env.GITHUB_ACTIONS === 'true' ||
				env.BUILDKITE === 'true' ||
				env.CIRCLECI === 'true' ||
				env.GITLAB_CI === 'true')
	} catch (_) {}

	return { isDuringBuild, hasWindow, inCI }
}

export const isInCI = () => getLifecycle().inCI

type Runtime = 'server' | 'client' | 'build' | 'rsc'

const checks: Record<Runtime, () => boolean> = {
	build() {
		const lifecycle = getLifecycle()
		return lifecycle.isDuringBuild
	},
	client() {
		const lifecycle = getLifecycle()
		return lifecycle.hasWindow
	},
	rsc() {
		return true
	},
	server() {
		const lifecycle = getLifecycle()
		return !lifecycle.isDuringBuild && !lifecycle.hasWindow
	},
}

export const getEnvVar = (key: string, expectedEnvironments: Runtime[]) => {
	try {
		for (const env of expectedEnvironments) {
			const check = checks[env]()
			if (check) {
				return process.env[key]
			}
		}
	} catch (err) {
		console.error('Error getting env var:', err)
	}
	console.log(`Returned empty env var for ${key}`)
	return 'NOTREAL'
}
